<template>
<div id="contents">

  <div id="works" class="page_contents vp_cm_page_contents">

    <div id="works_contents">
      <div id="works_vp_cm_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

          <worksPageNav/>

        <div id="works_vp_cm_index_main" class="page_main_contents">
          <div class="main_box" style="width: 100%">
            <h2>動画制作</h2>
            <p class="text" style="margin: 0 0 20px 0; text-align: center; font-size: 22px">テレビ朝日映像は “どこでも勝負できる動画” を制作します。<p>
            <p class="text" style="margin: 0 0 20px 0; font-weight: normal;">番組制作のノウハウを生かし、企画立案からキャスティング　撮影　制作までワンストップに動画制作を提供可能です。<p>
            <p class="text" style="margin: 0 0 20px 0; font-weight: normal;">これまでテレビ朝日映像は、テレビ番組制作だけでなく、官公庁、地方自治体、教育機関、民間企業の動画コンテンツを数多く制作してきました。<br />現在、さまざまなプラットフォームの特徴に合わせた動画制作が求められていますが、良いコンテンツを作るという本質は変わりません。<br />コンテンツの質が高ければ、どのプラットフォームでも通用します。<br />テレビ朝日映像だから作ることができる“どこでも勝負できる動画”をご提供しています。</p>
            <p class="text" style="margin: 0 0 20px 0;">制作動画ジャンル</p>
            <p class="text" style="margin: 0 0 0 0; font-weight: normal;">商品紹介　広告・CM　サービス紹介　アプリ紹介　会社紹介　人材採用　教育研修　社員総会　セミナー・説明会　営業ツール　展示会動画　<br />ドローン撮影　海外撮影　長尺動画　ミュージックビデオ（MV）　ゲーム　プロモーション　アニメーション　導入事例　施設・学校紹介　<br />広報・IR　ブランディング　デジタルサイネージ　PR動画　マニュアル　YouTube</p>
          </div><!-- .main_box -->
        </div><!-- #works_program_show_main -->

        <div id="works_vp_cm_index_body">
          <h2 class="cm_title">制作実績</h2>
          <div id="works_vp_cm_index_body_inner">
            <div class="vp_cm_box" v-for="vp_cm_item in vp_cm_items" :key="vp_cm_item.post_id" >
              <router-link v-bind:to="{name: 'vp_cm_show', params: {id: vp_cm_item.post_id, link: true}}" class="hover">
                <p class="img"><img :src="vp_cm_item.kv_image" width="" :alt="vp_cm_item.title" ></p>
                <h3>{{ vp_cm_item.title }}<br />{{ vp_cm_item.work_name }}</h3>
              </router-link>
            </div><!-- .vp_cm_box -->
          </div><!-- #works_vp_cm_index_body_inner -->

          <div id="works_vp_cm_index_body_works_list" class="page_main_contents">
            <div class="works_box">
              <h3>制作実績クライアント　（あいうえお順）</h3>
              <ul class="list"><li>アクティオ</li><li>朝日新聞</li><li>朝日生命</li><li>アサヒビール</li><li>足利フラワーリゾート（あしかがフラワーパーク）</li><li>ACG</li><li>アフラック</li><li>医食同源ドットコム</li><li>ウォルトディズニージャパン</li><li>AIG損害保険</li><li>ANA</li><li>HIS</li><li>ADK</li><li>ENEOS</li><li>花王</li><li>かんぽ生命保険</li><li>協栄産業</li><li>国分グループ本社</li><li>小林製薬</li><li>サントリー</li><li>集英社</li><li>JR東海</li><li>JR東日本</li><li>JA共済</li><li>J:COM</li><li>JSPORTS</li><li>実践学園</li><li>損保ジャパン日本興亜</li><li>武田薬品工業</li><li>竹中工務店</li><li>ダイダン</li><li>テレビ朝日</li><li>テレビ朝日ホールディングスグループ各社</li><li>電通</li><li>Tポイントカード</li><li>東武鉄道</li><li>凸版印刷</li><li>トヨタ自動車</li><li>東急エージェンシー</li><li>ナットウキナーゼ協会</li><li>日本損保保険協会</li><li>日本ハウスHD</li><li>日清食品ホールディングス</li><li>東日本ハウスホテル</li><li>博報堂</li><li>はま寿司</li><li>ファイザー</li><li>ボルテックス</li><li>マルエツ</li><li>明治</li><li>明治大学</li><li>明星大学</li><li>モエヘネシールイヴィトン</li><li>森永乳業</li><li>雪印メグミルク</li><li>ゆうちょ銀行</li><li>横浜国際展示場（パシフィコ横浜）</li><li>横浜八景島（横浜・八景島シーパラダイス及び品川アクアパーク）</li><li>読売広告社</li><li>吉徳</li><li>流通経済大学</li><li>霊友会</li></ul>
            </div><!-- .works_box -->
            <div class="works_box">
              <h3>中央省庁・地方自治体・他外郭団体</h3>
              <ul class="list"><li>厚労省</li><li>総務省</li><li>内閣府</li><li>農林水産省</li><li>防衛省</li><li>郵政省</li><li>警視庁</li><li>検察庁</li><li>公安調査庁</li><li>国税庁</li><li>消費庁</li><li>消防庁</li><li>防衛装備庁</li><li>文化庁</li><li>茨城県</li><li>神奈川県</li><li>埼玉県</li><li>静岡県</li><li>千葉県</li><li>東京都</li><li>警察協会</li><li>国際交流基金</li><li>最高裁判所</li><li>埼玉県立大学</li><li>JAXA</li><li>税務大学</li><li>東京観光財団</li><li>東京国立美術館</li><li>中小企業基盤整備</li><li>日本銀行</li><li>放送大学</li><li>防衛大学</li></ul>
            </div><!-- .works_box -->
          </div><!-- #works_vp_cm_index_body_works_list -->

        </div><!-- #works_vp_cm_index_body -->

        <div class="contact_btn_wrap mt70 mb80">
          <p class="contact_btn"><a href="https://movie.tv-asahipro.co.jp/" target="_blank" class="c_link">動画制作サービスへ</a></p>
        </div><!-- .contact_btn_wrap -->

      </div><!-- #works_vp_cm_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'vp_cm_index',
  data () {
    return {
      api_vp_cm_url: this.$parent.api_base_url+'/api/vp_cm/index.php',
      vp_cm_items: null,
      error: null
    }
  },
  components: {
    worksPageNav
  },
  methods: {
    fetch_vp_cm_item(){
      this.$axios
        .get(this.api_vp_cm_url)
        .then(response => {
          this.vp_cm_items = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    },
  },
  mounted () {
    this.fetch_vp_cm_item()
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/vp_cm_index.vue